import { Controller } from '@hotwired/stimulus'
import { wrapViewTransition } from '../helpers/view_transitions'

export default class extends Controller {
  static targets = ['frame', 'queryParamsInput', 'hint']

  static values = {
    url: String
  }

  connect () {
  }

  update () {
    const urlObj = new URL(this.urlValue)
    const paramsValue = this.queryParamsInputTarget.value

    if (paramsValue) {
      const inputParams = JSON.parse(this.queryParamsInputTarget.value)
      const queryParams = {
        latitude: parseFloat(inputParams.latitude).toFixed(6),
        longitude: parseFloat(inputParams.longitude).toFixed(6)
      }

      for (const [key, value] of Object.entries(queryParams)) {
        urlObj.searchParams.append(key, value)
      }

      if (urlObj.toString() !== this.frameTarget.src) {
        // Avoid reloading the frame if the URL hasn't changed
        // This prevents the UI from flickering
        wrapViewTransition(() => {
          this.frameTarget.src = urlObj.toString()
        })
      }

      this.show()
    } else {
      this.hide()
    }
  }

  show () {
    wrapViewTransition(() => {
      this.frameTarget.removeAttribute('hidden')
      if (this.hasHintTarget) this.hintTarget.setAttribute('hidden', true)
    })
  }

  hide () {
    wrapViewTransition(() => {
      this.frameTarget.setAttribute('hidden', true)
      if (this.hasHintTarget) this.hintTarget.removeAttribute('hidden')
    })
  }
}
